import { render, staticRenderFns } from "./SelectorTipoMetodoPagamentoMulti.vue?vue&type=template&id=4d78e83a&scoped=true"
import script from "./SelectorTipoMetodoPagamentoMulti.vue?vue&type=script&lang=js"
export * from "./SelectorTipoMetodoPagamentoMulti.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/vendor/libs/vue-multiselect/vue-multiselect.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78e83a",
  null
  
)

export default component.exports